//获取cookie、
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ';path=/';
};

//设置cookie,增加到vue实例方便全局调用
export function setRootCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString() + ";domain=.fanink.cn;");
};

//删除cookie
export function delCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
  // document.cookie = "name=value; expires=date; path=path; domain=.example.co.uk";
};


//删除根域名cookie
export function delRootCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999; path=path; domain=.fanink.cn;'
};
